import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';

const DeleteConfirmationChild = ({
  action,
  item,
  variant,
  disableButton,
  children,
  open,
  setOpen,
}) => {
  const REMOVE_ACCOUNT = "remove_account";
  const UNBLOCK_CONTACT = "unblock_contact";
  const BLOCK_CONTACT = "block_contact";
  const UNSUBSCRIBE = "unsubscribe";
  const REVOKE_ADMIN = "revoke_admin";
  const ME = "me";
  const DELETE_CHAT = "delete_chat";
  const DELETE_CALL = "delete_call";
  const DELETE_MEETING = "delete_meeting";
  const DELETE_CONFERENCE = "delete_conference";
  const CANCEL_EDIT = "cancel_edit";

  const handleClose = (e) => {

    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setOpen(false);
  };

  const handleRemove = (e) => {
   
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    
    
    if (action) {
      action(item);
    }
    
   
    setOpen(false);
  };

  const { t } = useTranslate();

  const DisplayDialogVariant = ({ variant }) => {
    let displayDialog = (
      <DialogContentText id="alert-dialog-description">
        {t('chat.remove_member')}
      </DialogContentText>
    );

    if (variant == REMOVE_ACCOUNT) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('profile.delete_account_info')}
        </DialogContentText>
      );
    }
    if (variant == UNBLOCK_CONTACT) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('block_contacts.unblockConfirmationMessage')}
        </DialogContentText>
      );
    }
    if (variant == BLOCK_CONTACT) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('block_contacts.blockConfirmationMessage')}
        </DialogContentText>
      );
    }
    if (variant == UNSUBSCRIBE) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('profile.unsubscribeConfirmationMessage')}
        </DialogContentText>
      );
    }
    if (variant == REVOKE_ADMIN) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('profile.revokeAdminConfirmationMessage')}
        </DialogContentText>
      );
    }
    if (variant == DELETE_CHAT) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('profile.deleteChat')}
        </DialogContentText>
      );
    }
    if (variant == DELETE_CALL) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('context_menu.delete_call_message')}
        </DialogContentText>
      );
    }
    if (variant == ME) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('chat_details.exit_group')}
        </DialogContentText>
      );
    }

    if (variant === DELETE_MEETING) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('meetings.delete_meeting')}
        </DialogContentText>
      );
    }

    if (variant === DELETE_CONFERENCE) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('conferences.delete_conference')}
        </DialogContentText>
      );
    }

    if (variant === CANCEL_EDIT) {
      displayDialog = (
        <DialogContentText id="alert-dialog-description">
          {t('chat.cancel_edit')}
        </DialogContentText>
      );
    }

    return displayDialog;
  };

  const DisplayConfirmationButton = ({ variant }) => {
    let displayDialog = `${t('general.yes')}`;

    if (variant == BLOCK_CONTACT) {
      displayDialog = `${t('block_contacts.block')}`;
    }
    if (variant == UNBLOCK_CONTACT) {
      displayDialog = `${t('block_contacts.unblock').toUpperCase()}`;
    }
    if (variant == UNSUBSCRIBE) {
      displayDialog = `${t('general.unsubscribe')}`;
    }
    if (variant == REVOKE_ADMIN) {
      displayDialog = `${t('profile.revokeAdmin')}`;
    }
    return displayDialog;
  };

  return (
    <>
      {children}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        
        onClick={(e) => e.stopPropagation()} 
      >
        <DialogTitle id="alert-dialog-title">{t('general.warning')}</DialogTitle>
        <DialogContent>
          <DisplayDialogVariant variant={variant} />
        </DialogContent>
        <DialogActions>
          
          <Button onClick={handleClose} type="button">
            {" "}
            {t('general.no')}
          </Button>
          
          
          <Button 
            style={{ color: "red" }} 
            onClick={handleRemove} 
            autoFocus 
            type="button" 
          >
            <DisplayConfirmationButton variant={variant} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteConfirmationChild;

const DeleteButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    height: 16px;
  }
  :disabled {
    cursor: inherit;
    opacity: 0.5;
  }
`;